import {
  ManageUsersData,
  TableCellAttribute,
  TableCellStyles,
  TableDataAdaptee,
  TableHeadData,
  TableRowData,
} from 'src/app/interfaces/tables.interfaces';
import { UserBasic } from 'src/app/swagger-api';
import {
  manageMemberTableHead,
  manageUsersTableRowData,
  membersManageTableCellAttributes,
} from '../table-users-list.data';
import { tableComponentStyles } from './table.styles';

export class ManageUsersTableDataAdaptee implements TableDataAdaptee {
  public constructor(private dictionary: ManageUsersData) {}

  public getTableHeadData(): TableHeadData[] {
    return manageMemberTableHead;
  }

  public getCellAttributes(): TableCellAttribute[] {
    return membersManageTableCellAttributes;
  }

  public getCellStyles(): TableCellStyles {
    return tableComponentStyles.members;
  }

  public createTableBody(): TableRowData[] {
    return this.dictionary.users.map((user: UserBasic, id: number) =>
      manageUsersTableRowData(id, user, this.dictionary.entity),
    );
  }
}
